import { environment } from '../environments/environment';
export class MenuConfig {
	public defaults: any = {
		aside: {
			self: {},
			items: [
				// {
				// 	title: 'Dashboard',
				// 	root: true,
				// 	icon: 'dashboard',
				// 	page: '/dashboard',
				// 	bullet: 'dot',
				// },
				{
					title: 'List of Cases',
					root: true,
					icon: 'list',
					page: '/cases/list',
					permission: [
						environment.customKeys.roleAdmin,
						environment.customKeys.roleInvestigators,
						environment.customKeys.rolePrefectureCommanders,
						environment.customKeys.roleRegionCommanders
					],
					bullet: 'dot'
				},
				{
					title: 'Map of Cases',
					root: true,
					icon: 'map',
					page: '/cases/map',
					permission: [
						environment.customKeys.roleAdmin,
						// environment.customKeys.roleInvestigators,
						environment.customKeys.rolePrefectureCommanders,
						environment.customKeys.roleRegionCommanders
					],
					bullet: 'dot'
				},
				{
					title: 'Archived Cases',
					root: true,
					icon: 'inventory_2',
					page: '/cases/archived',
					permission: [
						environment.customKeys.roleAdmin,
						// environment.customKeys.roleInvestigators,
						environment.customKeys.rolePrefectureCommanders,
						environment.customKeys.roleRegionCommanders
					],
					bullet: 'dot'
				},
				{
					title: 'Users',
					root: true,
					icon: 'group',
					page: '/users',
					permission: [
						environment.customKeys.roleAdmin,
						// environment.customKeys.roleInvestigators,
						environment.customKeys.rolePrefectureCommanders,
						environment.customKeys.roleRegionCommanders
					],
					bullet: 'dot'
				},
				{
					title: 'Cameras',
					root: true,
					icon: 'videocam',
					page: '/cameras',
					permission: [
						environment.customKeys.roleAdmin,
						// environment.customKeys.roleInvestigators,
						environment.customKeys.rolePrefectureCommanders,
						environment.customKeys.roleRegionCommanders
					],
					bullet: 'dot'
				},
				{
					title: 'Camera Groups',
					root: true,
					icon: 'group_work',
					page: '/camera-groups',
					permission: [
						environment.customKeys.roleAdmin,
						// environment.customKeys.roleInvestigators,
						environment.customKeys.rolePrefectureCommanders,
						environment.customKeys.roleRegionCommanders
					],
					bullet: 'dot'
				},
				{
					title: 'Devices',
					root: true,
					icon: 'smartphone',
					page: '/devices',
					permission: [
						environment.customKeys.roleAdmin,
						environment.customKeys.rolePrefectureCommanders
					],
					bullet: 'dot',
					requireConfigCheck: true
				},
				{
					title: 'Model Feedback',
					root: true,
					icon: 'feedback',
					page: '/model-feedback',
					permission: [
						environment.customKeys.roleAdmin,
						environment.customKeys.rolePrefectureCommanders
					],
					bullet: 'dot',
					superadmin: true
				},
				{
					title: 'Global Detection',
					root: true,
					icon: 'radar',
					page: '/global-detection',
					permission: [
						environment.customKeys.roleAdmin,
						environment.customKeys.rolePrefectureCommanders,
						environment.customKeys.roleInvestigators
					],
					bullet: 'dot',
					requireSurveillance: true
				},
				{
					title: 'Site Mapping',
					root: true,
					icon: 'layers',
					page: '/site-mapping',
					permission: [
						environment.customKeys.roleAdmin,
						environment.customKeys.rolePrefectureCommanders
					],
					bullet: 'dot',
					requireConfigCheck: true
				},
				// {
				// 	title: 'Vehicle Lookup',
				// 	root: true,
				// 	icon: 'car_crash',
				// 	page: '/car-plates',
				// 	permission: [
				// 		environment.customKeys.roleAdmin,
				// 		// environment.customKeys.roleInvestigators,
				// 		environment.customKeys.rolePrefectureCommanders,
				// 		environment.customKeys.roleRegionCommanders
				// 	],
				// 	bullet: 'dot'
				// }
			]
		},
	};

	public get configs(): any {
		return this.defaults;
	}
}
